import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const NotificationsPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Campañas</PageTitle>
      <View />
    </>
  );
};

export { NotificationsPage };
